import i18next from 'i18next';
import * as yup from 'yup';

export const schema = yup.object().shape({
  name: yup.string().required(i18next.t('validation.subjectGroup.nameRequired') as string),
});
